import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Grid, makeStyles } from "@material-ui/core/";
import BlogItems from "./BlogItems";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: "white",
    color: theme.palette.greenDark.main,
    position: "relative",
    zIndex: 2,
  },
  text: {
    color: theme.palette.greenDark.main,
  },
}));
const Blogitems = ({ blog, xs, sm, spacing, limit }) => {
  const { t } = useTranslation();

  const [blogFields, setBlogFields] = useState({
    imgUrl: "",
    author: "",
    isLoaded: false,
  });
  const [blogs, setBlogs] = useState({
    data: [],
    isLoaded: false,
  });

  useEffect(() => {
    if (i18n.language == "nl") {
      axios
        .get("https://cms.footprintforest.nl/wp-json/wp/v2/news")
        .then((result) => setBlogs({ data: result.data, isLoaded: true }))
        .catch((err) => console.log(err));
    } else {
      axios
        .get("https://cms.footprintforest.nl/wp-json/wp/v2/posts")
        .then((result) => setBlogs({ data: result.data, isLoaded: true }))
        .catch((err) => console.log(err));
    }
  }, []);

  if (blogs.data.length > 0) {
    return (
      <Grid container spacing={spacing}>
        {blogs.data.slice(0, limit).map((blog) => (
          <BlogItems key={blog.id} blog={blog} xs={12} sm={6} />
        ))}
      </Grid>
    );
  } else {
    return null;
  }
};
export default Blogitems;
